import popupMultiple from "./popupMultiple.vue";

export default popupMultiple;
